import React, { useEffect } from 'react'
import { Portal, useBoolean, useCustomUI } from '@sentecacommerce-theme/lib'
import styled from 'styled-components'

type CustomUIState = { isFooterInView: boolean }

export const StickyBottomStrip = ({
  children,
  show,
  mobile,
}: StickyBottomStripProps) => {
  const [isShown, setIsShown] = useBoolean(show)
  const [custom] = useCustomUI()

  useEffect(() => {
    if ((custom as CustomUIState).isFooterInView) {
      setIsShown.off()
    } else {
      setIsShown.on()
    }
  }, [(custom as CustomUIState).isFooterInView])

  return (
    <Portal>
      <Container mobile={mobile} show={isShown}>
        {children}
      </Container>
    </Portal>
  )
}

type StickyBottomStripProps = {
  children: JSX.Element
  show: boolean
  mobile?: boolean
}

const Container = styled.div.attrs({
  className: 'p-3 pb-5',
})<{ show?: boolean; mobile?: boolean }>`
  background: ${({ theme }) => theme.palette.secondary};
  border-top: 1px solid rgba(0, 0, 0, 0.2);
  width: 100%;
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 100;
  transition: transform 0.6s cubic-bezier(0.37, 0.06, 0.27, 0.83);
  transform: ${(props) => (props.show ? 'translateY(0)' : 'translateY(100%)')};
  /* opacity: ${(props) => (props.show ? '1' : '0')}; */

  @media (min-width: ${({ theme }) => theme.breakpoints.lg.min}) {
    display: ${(props) => (props.mobile ? 'none' : 'block')};
  }
`
